import GlobalNavigationShell from "components/v2/global-navigation-shell/GlobalNavigationShell";
import LoanCentricSidebarNav from "components/v2/loan-centric-sidebar-nav/LoanCentricSidebarNav";
import ShellProfileOverlay from "components/v2/shell-profile-overlay/ShellProfileOverlay";
import useDesktopChecker from "hooks/useDesktopChecker";
import { useLoanCentricSidebarNavEnabled } from "hooks/useLoanCentricSidebarNavEnabled";
import useTabletChecker from "hooks/useTabletChecker";
import HomeStub from "pages/home/HomeStub";

const HomeShellLayout = () => {
  const isDesktop = useDesktopChecker();
  const isTablet = useTabletChecker();
  const isMobilePhone = !isDesktop && !isTablet;
  const loanCentricSidebarNavEnabled = useLoanCentricSidebarNavEnabled();

  return (
    <div className="dashboard-shell">
      <GlobalNavigationShell
        notificationsEnabled={false}
        shellContext="home"
        hideFooter={loanCentricSidebarNavEnabled}
        navSlot={
          loanCentricSidebarNavEnabled && !isMobilePhone ? <LoanCentricSidebarNav /> : undefined
        }
        navSlotPlacement={loanCentricSidebarNavEnabled ? "sidebar" : "none"}
      >
        <ShellProfileOverlay>
          <HomeStub />
        </ShellProfileOverlay>
      </GlobalNavigationShell>
    </div>
  );
};

export default HomeShellLayout;
